<template>
  <div class="_container">
    <div class="bg_shape">
      <svg class="shape" viewBox="0 0 327.01 331"><path d="M97.52,328.2C12.26,311-41.32,70.63,40.85,22.2,180.27-60,322.22,104.92,327,210.59,330.09,281,182.79,345.35,97.52,328.2Z" /></svg>
      <svg class="shape" viewBox="0 0 327.01 331"><path d="M97.52,328.2C12.26,311-41.32,70.63,40.85,22.2,180.27-60,322.22,104.92,327,210.59,330.09,281,182.79,345.35,97.52,328.2Z" /></svg>
    </div>

    <div class="sign_in_up" @click="goToPage(linkSignUp.route)" v-html="linkSignUp.content" />

    <div class="_content">
      <div class="title" :style="{ 'text-align': 'left', 'margin-bottom': '30px' }" v-html="title" />

      <Decor class="illustration" />

      <Form :data="form" :show-tooltip="true" />
    </div>
  </div>
</template>

<script>

import Decor from '@/feature/sign_in/components/decor/Decor'
import Form from '@/feature/sign_in/components/utils/form/Form'
import { getCsrfToken } from '@/feature/sign_in/helpers'

export default {
  name: 'Password',
  components: {
    Form,
    Decor
  },
  props: {
    email: {
      required: false,
      type: String,
      default: ''
    }
  },
  data () {
    return {
      linkSignUp: {
        content: '<span>' + window.I18n.t('login.shared.not_have_account') + '</span> <span>' + window.I18n.t('register.title') + '</span>',
        route: '/signup'
      },
      title: window.I18n.t('login.shared.reset_your_password').replace(/\n/g, '<br/>'),
      form: {
        submit: this.submit,
        action: '/users/password',
        method: 'POST',
        inputs: [
          {
            type: 'text',
            name: 'user[email]',
            icon: 'fal fa-envelope',
            placeholder: window.I18n.t('widget.email_placeholder_content'),
            onInput: this.syncEmail,
            value: this.email,
            controller: {
              error: false,
              list: [
                [(input) => { return input.value.trim() === '' }, window.I18n.t('register.validations.required', { input: window.I18n.t('roles.index.email') })],
                [(input) => { return !/\S+@\S+\.\S+/.test(input.value) }, window.I18n.t('register.validations.not_valid_email')]
              ]
            }
          },
          {
            type: 'error',
            name: 'alert',
            value: { errors: this.$appParams.flashAlert ? { flashAlert: { message: this.$appParams.flashAlert } } : {}, messages: {} }
          },
          [
            {
              type: 'link',
              content: window.I18n.t('login.shared.title'),
              style: { 'margin-top': '18px' },
              route: 'signin'
            },
            {
              type: 'submit',
              content: window.I18n.t('login.shared.reset_pwd'),
              style: { 'white-space': 'nowrap', 'margin-bottom': '48px', 'margin-top': '10px' }
            }
          ],
          [
            {
              type: 'hidden',
              name: 'authenticity_token',
              value: getCsrfToken()
            },
            {
              type: 'hidden',
              name: 'utf8',
              value: '✓'
            },
            {
              type: 'hidden',
              name: 'request_type',
              value: this.$appParams.submitJs ? 'js' : ''
            }
          ]
        ]
        // autofocus: 'user[email]'
      }
    }
  },
  methods: {
    goToPage (route) {
      this.$router.push(route)
    },
    syncEmail (input) {
      this.$emit('syncEmail', input.value)
    },
    submit (event) {
      if (this.$appParams.submitJs) {
        event.preventDefault()
        event.stopPropagation()
        this.$emit('submit', this.form)
      }
    }
  }
}

</script>

<style scoped src="@/feature/sign_in/assets/css/page.css"></style>

<style scoped>

._container ._content .illustration {
  margin-bottom: 10px;
}

</style>
